'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

require('slick-carousel');

var _handlers = require('./handlers');

var sliderSettings = {
  centerMode: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  swipeToSlide: true,
  rows: 0,
  prevArrow: '<div class=\'slick-prev\'></div>',
  nextArrow: '<div class=\'slick-next\'></div>',
  responsive: [{
    breakpoint: 1279,
    settings: {
      centerMode: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      draggable: true,
      swipeToSlide: true,
      arrows: true,
      prevArrow: '<div class=\'slick-prev\'></div>',
      nextArrow: '<div class=\'slick-next\'></div>'
    }
  }, {
    breakpoint: 600,
    settings: {
      centerMode: true,
      slidesToShow: 1,
      draggable: true,
      swipeToSlide: true,
      arrows: true,
      prevArrow: '<div class=\'slick-prev\'></div>',
      nextArrow: '<div class=\'slick-next\'></div>'
    }
  }]
};

var bindActions = exports.bindActions = function bindActions() {
  $(document).on('mouseenter', '.prod-grid-image-link', function (_ref) {
    var self = _ref.currentTarget;

    (0, _handlers.mouseEnter)(self);
  });
  $(document).on('mouseleave', '.prod-grid-image-link', function (_ref2) {
    var self = _ref2.currentTarget;

    (0, _handlers.mouseLeave)(self);
  });

  $('.product-grid-item').each(function (index, element) {
    var slider = $(element).find('[data-variant-slider]');

    if (slider.children().length > 5) {
      slider.slick(sliderSettings);
    }
  });
};